import MenuDetailsView from '@/views/MyMenus/MenuDetailsView.vue';
import MyMenusView from '@/views/MyMenus/MyMenusView.vue';
import DishTagsView from '@/views/MyRecipes/DishTagsView.vue';
import FavoritesView from '@/views/MyRecipes/FavoritesView.vue';
import GeneratedTitlesView from '@/views/MyRecipes/GeneratedTitlesView.vue';
import GenerationHistoryView from '@/views/MyRecipes/GenerationHistoryView.vue';
import MyRecipesView from '@/views/MyRecipes/MyRecipesView.vue';
import MyScansView from '@/views/MyRecipes/MyScansView.vue';
import PlannedView from '@/views/MyRecipes/PlannedView.vue';
import TagView from '@/views/MyRecipes/TagView.vue';
import DishCreationFormView from '@/views/Profile/DishCreationFormView.vue';

const myRecipesRoutes = [
  {
    path: '/my-recipes',
    name: 'my-recipes',
    meta: {
      headerConfig: {
        headerLabel: 'myRecipes',
        hide: false,
        showBack: false,
        showProfile: true,
      },
      footerConfig: {
        hide: false,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
      },
      containerMargins: true,
    },
    component: MyRecipesView,
  },
  {
    path: '/my-recipes/generation-history',
    name: 'generation-history',
    meta: {
      headerConfig: {
        headerLabel: 'history',
        hide: false,
        showBack: true,
        showProfile: true,
      },
      footerConfig: {
        hide: false,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
        restaurantRoleAllowed: ['admin', 'manager'],
      },
      containerMargins: true,
    },
    component: GenerationHistoryView,
  },
  {
    path: '/my-recipes/my-scans',
    name: 'my-scans',
    meta: {
      headerConfig: {
        headerLabel: 'myScans',
        hide: false,
        showBack: true,
        showProfile: true,
      },
      footerConfig: {
        hide: false,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
        restaurantRoleAllowed: ['admin', 'manager'],
      },
      containerMargins: true,
    },
    component: MyScansView,
  },
  {
    path: '/my-recipes/add-edit-recipe',
    name: 'dish-creation-edition-form',
    meta: {
      headerConfig: {
        headerLabel: 'menu',
        hide: false,
        showBack: true,
        showProfile: false,
      },
      footerConfig: {
        hide: true,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
      },
      containerMargins: true,
    },
    props: (route) => ({ dishEdition: route.query.edit === 'true' ? true : false }),
    component: DishCreationFormView,
  },
  {
    path: '/my-recipes/favorites',
    name: 'favorites',
    meta: {
      headerConfig: {
        headerLabel: 'myFavorites',
        hide: false,
        showBack: true,
        showProfile: false,
      },
      footerConfig: {
        hide: true,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
      },
      containerMargins: true,
    },
    component: FavoritesView,
  },
  {
    path: '/my-recipes/planned',
    name: 'planned',
    meta: {
      headerConfig: {
        headerLabel: 'planned',
        hide: false,
        showBack: true,
        showProfile: false,
      },
      footerConfig: {
        hide: true,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
      },
      containerMargins: true,
    },
    component: PlannedView,
  },
  {
    path: '/my-recipes/titles',
    name: 'titles',
    meta: {
      headerConfig: {
        headerLabel: 'generatedTitles',
        hide: false,
        showBack: true,
        showProfile: false,
      },
      footerConfig: {
        hide: true,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
        restaurantRoleAllowed: ['admin', 'manager'],
      },
      containerMargins: true,
    },
    component: GeneratedTitlesView,
  },
  {
    path: '/my-recipes/tags',
    name: 'dish-tag-list',
    meta: {
      headerConfig: {
        headerLabel: 'myTags',
        hide: false,
        showBack: true,
        showProfile: true,
      },
      footerConfig: {
        hide: false,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
        restaurantRoleAllowed: ['admin', 'manager'],
      },
      containerMargins: true,
    },
    component: DishTagsView,
  },
  {
    path: '/my-recipes/tags/:parentId',
    name: 'dish-tag-children',
    meta: {
      headerConfig: {
        headerLabel: 'myTags',
        hide: false,
        showBack: true,
        showProfile: true,
      },
      footerConfig: {
        hide: false,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
        restaurantRoleAllowed: ['admin', 'manager'],
      },
      containerMargins: true,
    },
    component: DishTagsView,
  },
  {
    path: '/my-recipes/tags/:parentId/:tagId',
    name: 'dish-tag-dishes',
    meta: {
      headerConfig: {
        headerLabel: 'menu',
        hide: false,
        showBack: true,
        showProfile: true,
      },
      footerConfig: {
        hide: false,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
        restaurantRoleAllowed: ['admin', 'manager'],
      },
      containerMargins: true,
    },
    component: TagView,
  },
  {
    path: '/my-recipes/my-menus',
    name: 'my-menus',
    meta: {
      headerConfig: {
        headerLabel: 'myMenus',
        hide: false,
        showBack: true,
        showProfile: true,
      },
      footerConfig: {
        hide: false,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
      },
      containerMargins: true,
    },
    component: MyMenusView,
  },
  {
    path: '/my-recipes/my-menus/:menuId',
    name: 'menu-details',
    meta: {
      headerConfig: {
        headerLabel: 'myMenus',
        hide: false,
        showBack: true,
        showProfile: true,
      },
      footerConfig: {
        hide: false,
      },
      securityConfig: {
        requireAuthentication: true,
        rolesAllowed: ['common', 'admin'],
      },
      containerMargins: true,
    },
    component: MenuDetailsView,
  },
];

export default myRecipesRoutes;
